import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export function HomePage() {
  const { user } = useAuth()
  return (
    <>
      <section className="hero-section entertainment-hero">
        <div className="hero-copy">
          <span className="eyebrow">互動式段落播放器</span>
          <h1>想唱哪一段，就從那裡開始</h1>
          <p>把一首 YouTube 歌曲切成段落；播放時可選好下一段，再依路徑跳轉。</p>
          <div className="button-row">
            <Link className="button button--primary button--large" to={user ? '/projects/new' : '/login'}>
              {user ? '建立作品' : '登入後建立作品'}
            </Link>
            <Link className="button button--large" to="/explore">
              探索公開作品
            </Link>
          </div>
        </div>
        <div className="hero-visual entertainment-visual">
          <div className="visual-screen">
            <img
              src="/assets/ilovesing-segment-stage-v1.png"
              alt="抽象段落舞台，四個歌曲段落沿著路徑排列"
            />
            <span className="visual-screen__shade" aria-hidden="true" />
            <span className="visual-play" aria-hidden="true" />
            <div className="visual-now">
              <span>目前：副歌</span>
              <strong>01:05–01:42</strong>
            </div>
          </div>
          <div className="visual-timeline" aria-label="四個段落，第三段目前播放中">
            <span />
            <span />
            <span className="is-active" />
            <span />
          </div>
        </div>
      </section>

      <section className="section home-process">
        <div className="section-heading">
          <h2>從影片到你的練唱路徑</h2>
        </div>
        <div className="process-path">
          <article className="process-step">
            <span>1</span>
            <h3>貼上影片</h3>
            <p>選擇可嵌入的 YouTube 影片，帶進你的歌曲資料。</p>
          </article>
          <article className="process-step">
            <span>2</span>
            <h3>標記段落</h3>
            <p>在想練習的位置留下節點，排列每一段的開始時間。</p>
          </article>
          <article className="process-step">
            <span>3</span>
            <h3>開始練唱</h3>
            <p>播放前先選好下一個段落，在段落結束時依你的選擇切換。</p>
          </article>
        </div>
      </section>

      <section className="section boundary-section">
        <div>
          <h2>播放限制</h2>
        </div>
        <p>
          YouTube seek 可能落在附近的 keyframe，也可能受網路、緩衝、廣告、自動播放或影片禁止嵌入影響。iLoveSing
          適合練習與編排，不提供專業無縫混音。
        </p>
      </section>
    </>
  )
}
